module.exports = __webpack_public_path__ + "static/media/enterpriseservices.e67e8ea6.png";